export default __webpack_public_path__ + "static/media/newFileIcon.bcd398d6.svg";